import $axios from "../../api";

// MODULE NAME
const PREFIX = "website/featured"

const state = () => ({
  isLoading: false,
  errors: [],
  isSuccess: false,
  list: [],
  detail: null,
});

const getters = {
  getProcessedList: (state) => {
    return state.list.map(element => ({
        ...element,
        sku: element.sku.replaceAll('.', '')
      }));
  }
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX}/list?`, {
            params: {
              view: rootState.Main.view,
              product_name: payload?.product || '',
            }
          }
        )
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  create({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(
          `${PREFIX}/create`, payload
        )
        .then((res) => {
          commit("SET_LOADING", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

